import React, { PureComponent } from 'react'

const pinStyle = {
  cursor: 'pointer',
  fill: '#00558B',
  stroke: 'none',
}

export class DefaultMarker extends PureComponent {
  render() {
    const { size = 20, onClick, className, hovered } = this.props
    const width = size * 2
    const height = size * 2
    let transform = `translate(-${size}px,-${size}px)`
    if (hovered) transform += ' scale(1.6)'

    return (
      <svg
        height={height}
        width={width}
        className={className}
        style={{ transform: transform, transition: 'all .2s ease-out' }}
        onClick={onClick}
      >
        <g
          id="Material-Design-Stickersheet"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="AIS_no_error_message" transform="translate(-826.000000, -1104.000000)">
            <g id="outline-trip_origin-24px-copy" transform="translate(824.000000, 1102.000000)">
              <g id="Bounding_Boxes">
                <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
              </g>
              <circle id="Oval-5" fill="#FFFFFF" cx="12" cy="12" r="8" />
              <g id="Outline" transform="translate(2.000000, 2.000000)">
                <path
                  d="M0,10 C0,4.48 4.48,0 10,0 C15.52,0 20,4.48 20,10 C20,15.52 15.52,20 10,20 C4.48,20 0,15.52 0,10 Z M10,18 C14.4133333,18 18,14.4133333 18,10 C18,5.58666667 14.4133333,2 10,2 C5.58666667,2 2,5.58666667 2,10 C2,14.4133333 5.58666667,18 10,18 Z M10,16 C13.31,16 16,13.31 16,10 C16,6.69 13.31,4 10,4 C6.69,4 4,6.69 4,10 C4,13.31 6.69,16 10,16 Z"
                  id="Shape"
                  fill="#F59948"
                  fillRule="nonzero"
                />
                <path
                  d="M10,14 C12.2066667,14 14,12.2066667 14,10 C14,7.79333333 12.2066667,6 10,6 C7.79333333,6 6,7.79333333 6,10 C6,12.2066667 7.79333333,14 10,14 Z"
                  id="Path-Copy-2"
                  fill="#FFFFFF"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

export class LoadMarker extends PureComponent {
  render() {
    const { size = 25, onClick, className } = this.props
    return (
      <svg
        className={className}
        onClick={onClick}
        style={{
          ...pinStyle,
          transform: `translate(-12.5px, -22px)`,
          width: size,
          height: size,
        }}
      >
        <g
          id="Material-Design-Stickersheet"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="AIS_no_error_message" transform="translate(-493.000000, -1067.000000)">
            <g id="outline-place-24px-copy" transform="translate(487.000000, 1065.000000)">
              <g id="Bounding_Boxes">
                <polygon id="Shape" points="0 0 32 0 32 32 0 32" />
              </g>
              <g id="Outline" transform="translate(6.666667, 2.666667)">
                <g id="Group">
                  <path
                    d="M9.33333333,2.66666667 C12.1671352,3.72269073 13.944913,4.61157962 14.6666667,5.33333333 C15.3884204,6.05508705 15.8328648,7.38842038 16,9.33333333 C15.7324288,11.6462535 15.2879843,13.4240313 14.6666667,14.6666667 C14.045349,15.909302 12.2675712,18.5759687 9.33333333,22.6666667 C7.39486488,19.6786187 6.06153155,17.4563964 5.33333333,16 C4.60513512,14.5436036 3.71624623,12.3213813 2.66666667,9.33333333 C3.74785913,6.4743631 4.63674802,4.69658532 5.33333333,4 C6.02991865,3.30341468 7.36325198,2.85897024 9.33333333,2.66666667 Z"
                    id="Path-4"
                    stroke="#FFFFFF"
                    strokeWidth="1.33333333"
                    fill="#FFFFFF"
                  />
                  <path
                    d="M9.33333333,0 C4.17333333,0 0,4.17333333 0,9.33333333 C0,16.3333333 9.33333333,26.6666667 9.33333333,26.6666667 C9.33333333,26.6666667 18.6666667,16.3333333 18.6666667,9.33333333 C18.6666667,4.17333333 14.4933333,0 9.33333333,0 Z M2.66666667,9.33333333 C2.66666667,5.65333333 5.65333333,2.66666667 9.33333333,2.66666667 C13.0133333,2.66666667 16,5.65333333 16,9.33333333 C16,13.1733333 12.16,18.92 9.33333333,22.5066667 C6.56,18.9466667 2.66666667,13.1333333 2.66666667,9.33333333 Z"
                    id="Shape"
                    fill="#00558B"
                    fillRule="nonzero"
                  />
                  <circle
                    id="Oval"
                    fill="#00558B"
                    fillRule="nonzero"
                    cx="9.33333333"
                    cy="9.33333333"
                    r="3.33333333"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

export class DeliveryMarker extends PureComponent {
  render() {
    const { size = 25, onClick, className } = this.props
    return (
      <svg
        onClick={onClick}
        className={className}
        style={{
          ...pinStyle,
          transform: `translate(-1.5px, -20px)`,
          width: size,
          height: size,
        }}
      >
        <g
          id="Material-Design-Stickersheet"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="AIS_no_error_message" transform="translate(-1055.000000, -1080.000000)">
            <g
              id="baseline-outlined_flag-24px-copy"
              transform="translate(1049.000000, 1075.000000)"
            >
              <path
                d="M18.6666667,8 L17.3333333,5.33333333 L6.66666667,5.33333333 L6.66666667,28 L9.33333333,28 L9.33333333,18.6666667 L16,18.6666667 L17.3333333,21.3333333 L26.6666667,21.3333333 L26.6666667,8 L18.6666667,8 Z M24,18.6666667 L18.6666667,18.6666667 L17.3333333,16 L9.33333333,16 L9.33333333,8 L16,8 L17.3333333,10.6666667 L24,10.6666667 L24,18.6666667 Z"
                id="Shape"
                fill="#00558B"
                fillRule="nonzero"
              />
              <polygon id="Shape" points="0 0 32 0 32 32 0 32" />
              <polygon
                id="Path-5"
                fill="#FFFFFF"
                points="9.33333333 8 9.33333333 16 17.3333333 16 18.6666667 18.6666667 24 18.6666667 24 10.6666667 17.3333333 10.6666667 16 8"
              />
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

export class LocationMarker extends PureComponent {
  static defaultProps = {
    onClick: () => {},
  }

  render() {
    const { onClick } = this.props

    return (
      <React.Fragment>
        <svg
          height="50"
          width="50"
          style={{ transform: `translate(-15px,-40px)` }}
          onClick={onClick}
        >
          <g id="shipments_v2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="shipments_list_separator" transform="translate(-1243.000000, -529.000000)">
              <g id="Group-2" transform="translate(1243.000000, 529.000000)">
                <g id="Material/Icons-black/place-Copy-2" fill="#00558B">
                  <path
                    d="M15,0.166666667 C6.9375,0.166666667 0.416666667,6.6875 0.416666667,14.75 C0.416666667,25.6875 15,41.8333333 15,41.8333333 C15,41.8333333 29.5833333,25.6875 29.5833333,14.75 C29.5833333,6.6875 23.0625,0.166666667 15,0.166666667 L15,0.166666667 Z"
                    id="Shape"
                  />
                </g>
                <g id="container" transform="translate(6.000000, 10.000000)">
                  <rect
                    id="Rectangle-18"
                    fill="#FFFFFF"
                    x="0"
                    y="0"
                    width="19"
                    height="11"
                    rx="0.382747372"
                  />
                  <path d="M7.5,2 L7.5,9" id="Path-5" stroke="#00558B" strokeWidth="1.41935484" />
                  <path d="M3.5,2 L3.5,9" id="Path-5" stroke="#00558B" strokeWidth="1.41935484" />
                  <path d="M15.5,2 L15.5,9" id="Path-5" stroke="#00558B" strokeWidth="1.41935484" />
                  <polyline
                    id="Path-5"
                    stroke="#00558B"
                    strokeWidth="1.41935484"
                    points="11.5 2 11.5 3.35582746 11.5 9"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      </React.Fragment>
    )
  }
}

export class VesselMarker extends PureComponent {
  static defaultProps = {
    onClick: () => {},
  }

  render() {
    const { onClick } = this.props

    return (
      <React.Fragment>
        <svg
          height={'50'}
          width={'50'}
          style={{ transform: `translate(-22px,-48px)` }}
          onClick={onClick}
        >
          <g
            id="Material-Design-Stickersheet"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="AIS_no_error_message" transform="translate(-865.000000, -1017.000000)">
              <g id="outline-person_pin-24px-copy" transform="translate(863.000000, 1017.000000)">
                <g id="Bounding_Boxes" transform="translate(0.000000, 1.724138)">
                  <polygon id="Shape" points="0 0 48 0 48 48.2758621 0 48.2758621" />
                </g>
                <g id="Outline" transform="translate(2.571429, 0.574713)">
                  <g id="Group">
                    <g id="outline-directions_boat-24px" transform="translate(3.142857, 4.022989)">
                      <text x="20" y="35" fill="black" fontSize={6}>
                        2
                      </text>
                      <g
                        id="Bounding_Boxes"
                        transform="translate(0.000000, -0.000000)"
                        fill="#FFFFFF"
                        stroke="#FFFFFF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2.44897959"
                      >
                        <polygon
                          id="Path-3"
                          points="0 -4.54747351e-13 34.2857143 -4.54747351e-13 34.2857143 34.6982759 22.0408163 34.6982759 17.1428571 39.6551724 12.244898 34.6982759 0 34.6982759"
                        />
                      </g>
                      <g
                        id="Outline"
                        transform="translate(7.166667, 6.345785)"
                        fill="#00558B"
                        fillRule="nonzero"
                      >
                        <path
                          d="M11.315364,2.03761755 L11.315364,3.05642633 L9.25846081,3.05642633 L9.25846081,2.03761755 L11.315364,2.03761755 Z M10.2869124,9.28134796 L15.8199821,11.0846395 L18.2779815,11.8793103 L17.1261157,15.9239812 C16.5707518,15.6183386 16.1593711,15.200627 15.9536808,14.9663009 L14.4007189,13.2037618 L12.8477569,14.9561129 C12.4980834,15.3636364 11.5313389,16.3009404 10.2869124,16.3009404 C9.04248598,16.3009404 8.07574146,15.3636364 7.72606791,14.9561129 L6.17310597,13.2037618 L4.62014403,14.9561129 C4.41445371,15.1904389 4.00307307,15.5979624 3.44770919,15.903605 L2.28555887,11.8691223 L4.75384274,11.0642633 L10.2869124,9.28134796 Z M13.3722673,0 L7.20155759,0 L7.20155759,3.05642633 L4.11620274,3.05642633 C2.98490597,3.05642633 2.05929952,3.97335423 2.05929952,5.09404389 L2.05929952,9.80094044 L0.732596933,10.2288401 C0.465199513,10.3103448 0.238940158,10.4937304 0.115525965,10.7382445 C-0.00788822917,10.9827586 -0.0387417776,11.2680251 0.0538188677,11.5329154 L2.00787693,18.338558 L2.05929952,18.338558 C3.7048221,18.338558 5.16522339,17.4420063 6.17310597,16.3009404 C7.18098855,17.4420063 8.64138985,18.338558 10.2869124,18.338558 C11.932435,18.338558 13.3928363,17.4420063 14.4007189,16.3009404 C15.4086015,17.4420063 16.8690028,18.338558 18.5145253,18.338558 L18.5659479,18.338558 L20.5097215,11.5329154 C20.5919976,11.2680251 20.5714286,10.9827586 20.4480144,10.7382445 C20.3246002,10.4937304 20.0983408,10.3103448 19.8309434,10.2288401 L18.5145253,9.80094044 L18.5145253,5.09404389 C18.5145253,3.97335423 17.5889189,3.05642633 16.4576221,3.05642633 L13.3722673,3.05642633 L13.3722673,0 Z M4.11620274,9.13871473 L4.11620274,5.09404389 L16.4576221,5.09404389 L16.4576221,9.13871473 L10.2869124,7.13166144 L4.11620274,9.13871473 Z M14.4007189,19.031348 C13.1460079,19.8973354 11.7164602,20.3354232 10.2869124,20.3354232 C8.85736469,20.3354232 7.42781694,19.8973354 6.17310597,19.031348 C4.918395,19.8973354 3.48884726,20.3761755 2.05929952,20.3761755 L0.00239628698,20.3761755 L0.00239628698,22.4137931 L2.05929952,22.4137931 C3.47856274,22.4137931 4.87725694,22.05721 6.17310597,21.4051724 C7.46895501,22.05721 8.87793372,22.3934169 10.2869124,22.3934169 C11.6958911,22.3934169 13.1048699,22.0673981 14.4007189,21.4051724 C15.6965679,22.0673981 17.0952621,22.4137931 18.5145253,22.4137931 L20.5714286,22.4137931 L20.5714286,20.3761755 L18.5145253,20.3761755 C17.0849776,20.3761755 15.6554299,19.8973354 14.4007189,19.031348 Z"
                          id="Shape"
                        />
                      </g>
                    </g>
                    <path
                      d="M36.5714286,0 L4.57142857,0 C2.03428571,0 0,2.06896552 0,4.59770115 L0,36.7816092 C0,39.3103448 2.03428571,41.3793103 4.57142857,41.3793103 L13.7142857,41.3793103 L20.5714286,48.2758621 L27.4285714,41.3793103 L36.5714286,41.3793103 C39.0857143,41.3793103 41.1428571,39.3103448 41.1428571,36.7816092 L41.1428571,4.59770115 C41.1428571,2.06896552 39.0857143,0 36.5714286,0 Z M36.5714286,36.7816092 L27.4285714,36.7816092 L25.5314286,36.7816092 L24.1828571,38.137931 L20.5714286,41.7701149 L16.9371429,38.1149425 L15.6114286,36.7816092 L13.7142857,36.7816092 L4.57142857,36.7816092 L4.57142857,4.59770115 L36.5714286,4.59770115 L36.5714286,36.7816092 Z"
                      id="Shape"
                      fill="#00558B"
                      fillRule="nonzero"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </React.Fragment>
    )
  }
}

export class RailMarker extends PureComponent {
  static defaultProps = {
    onClick: () => {},
    height: 49,
    width: 42,
    transform: 'translate(-22px,-48px)',
  }

  render() {
    const { onClick, height, transform, width } = this.props

    return (
      <React.Fragment>
        <svg height={height} width={width} style={{ transform }} onClick={onClick}>
          <g fill="none" fillRule="evenodd">
            <polygon
              fill="#FFF"
              points="5.143 2.937 39.714 2.937 39.714 38.538 28.021 38.538 19.571 45.201 15.722 38.538 3.143 38.538 3.143 2.937"
            />
            <path
              fill="#00558B"
              fillRule="nonzero"
              d="M36.5714286,0 L4.57142857,0 C2.03428571,0 0,2.06896552 0,4.59770115 L0,36.7816092 C0,39.3103448 2.03428571,41.3793103 4.57142857,41.3793103 L13.7142857,41.3793103 L20.5714286,48.2758621 L27.4285714,41.3793103 L36.5714286,41.3793103 C39.0857143,41.3793103 41.1428571,39.3103448 41.1428571,36.7816092 L41.1428571,4.59770115 C41.1428571,2.06896552 39.0857143,0 36.5714286,0 Z M36.5714286,36.7816092 L27.4285714,36.7816092 L25.5314286,36.7816092 L24.1828571,38.137931 L20.5714286,41.7701149 L16.9371429,38.1149425 L15.6114286,36.7816092 L13.7142857,36.7816092 L4.57142857,36.7816092 L4.57142857,4.59770115 L36.5714286,4.59770115 L36.5714286,36.7816092 Z"
              transform="translate(.571 .575)"
            />
            <path
              fill="#00558B"
              fillRule="nonzero"
              stroke="#00558B"
              d="M22.9713307,24.0587242 L16.3446882,0.526828599 C16.2333161,0.139244437 15.8156705,-0.0822322275 15.425868,0.0285061046 C15.0360655,0.139244437 14.8133213,0.554513182 14.9246934,0.942097345 L16.0662579,5.01173105 L6.93374213,5.01173105 L8.0753066,0.942097345 C8.18667874,0.554513182 7.96393446,0.139244437 7.57413196,0.0285061046 C7.18432945,-0.0822322275 6.76668392,0.139244437 6.65531177,0.526828599 L0.0286692593,24.0587242 C-0.0827028838,24.4463083 0.140041402,24.8615771 0.529843903,24.9723154 C0.585529975,25 0.669059082,25 0.724745154,25 C1.05886158,25 1.33729194,24.7785233 1.44866408,24.4739929 L3.00787409,18.9370763 L19.9921259,18.9370763 L21.5513359,24.4739929 C21.634865,24.8062079 21.9411384,25 22.2752548,25 C22.3309409,25 22.41447,25 22.4701561,24.9723154 C22.8599586,24.8615771 23.0827029,24.4463083 22.9713307,24.0587242 Z M17.5697818,10.8032227 L5.4302182,10.8032227 L6.5160966,6.45132937 L16.4839034,6.45132937 L17.5697818,10.8032227 Z M3.42551962,16.9194336 L5.01257266,12.3798828 L17.9874273,12.3798828 L19.5744804,16.9194336 L3.42551962,16.9194336 Z"
              transform="translate(10 9)"
            />
          </g>
        </svg>
      </React.Fragment>
    )
  }
}
